<template>
  <v-expansion-panels v-model="openPanelsCommunity" v-if="item.community" class="my-5">
      <v-expansion-panel>
        <v-expansion-panel-header>{{$t('community')}} ({{communityCounter}})</v-expansion-panel-header>
        <v-expansion-panel-content>

          <v-card v-for="(community, i) in item.community" :key="`${i}-community-${community.name}`" outlined class="mb-5">

            <AdCardTitle inline v-if="community.displayName">{{community.displayName}}</AdCardTitle>

            <v-alert v-if="community.desc" type="info" dense text class="mb-5">
              <div v-html="$filters.getMatchingTranslation({ value: community.desc })"></div>
            </v-alert>

            <MyCommunityAssociationsTable :community="community" readonly />
          </v-card>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import MyCommunityAssociationsTable from '../Project/MyCommunityAssociationsTable'
export default {
  name: 'CommunitySection',
  components: { MyCommunityAssociationsTable },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      openPanelsCommunity: []
    }
  },
  computed: {
    communityCounter () {
      let counter = 0
      if (this.item?.community) {
        this.item.community.forEach((community) => {
          counter += community?.associations?.[0]?.association?.[0]?.data.length || 0
        })
      }
      return counter
    }
  }
}
</script>

<style>

</style>
